import React, { useEffect, useState } from 'react';
import { useGetUserSystemPermissions } from '../../queries/user-query';
import { Button, ButtonVariantProps } from '../../components/atoms/Button';
import { HorizontalAlignProps, InlineGroup } from '../../components/atoms/InlineGroup';
import { PageContainer } from '../../components/atoms/PageContainer';
import { Typography, TypographyVariantProps } from '../../components/atoms/Typography';
import { ClientContractList } from './ClientContractList';
import AddIcon from '@mui/icons-material/Add';
import { ActionPermissions, CustomPermission } from '../../@types';
import { isUserHasPermission } from '../../configs/permissions';
import { Link } from '../../components/atoms/Link';
import { Wrapper } from '../../styled/common.styles';
import { PLATFORM_NAME } from '../../configs/common';
import { TabHandler } from '../../handlers/TabHandler';

export const ClientAndContract: React.FC = () => {
  const [permissions, setPermissions] = useState<CustomPermission[]>();
  const getUserPermissionsQuery = useGetUserSystemPermissions();

  useEffect(() => {
    getUserPermissionsQuery.data && setPermissions(getUserPermissionsQuery.data);
  }, [getUserPermissionsQuery.data]);

  TabHandler(`List Clients | ${PLATFORM_NAME}`);
  
  return (
    <PageContainer>
      <Wrapper>
        <InlineGroup horizontal={HorizontalAlignProps.Between}>
          <Typography variant={TypographyVariantProps.H5} fontWeight={600}>
            List Clients
          </Typography>
          {isUserHasPermission(ActionPermissions.Configure_Clients_or_Contracts_Create, permissions) && (
            <Link href="configure/clients/client/create">
              <Button variant={ButtonVariantProps.Primary} startIcon={<AddIcon />}>
                Add client
              </Button>
            </Link>
          )}
        </InlineGroup>
        <ClientContractList/>
      </Wrapper>
    </PageContainer> 
  );
};